import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { CoreComponent } from '@app/core/core.component';
import { MessageDescriptionDialogComponent } from './message-description-dialog/message-description-dialog.component';

import { AiGenerateTextService } from './ai-generate-text.service';

import { IMessageDescriptionDialogData } from '@lib/message-description.interface';
import { IGenerateTextData, IGenerateTextPayload } from '@lib/generate-ai-text.interface';

@Component({
  selector: 'ai-generate-text',
  templateUrl: './ai-generate-text.component.html',
  styleUrls: ['./ai-generate-text.component.scss']
})
export class AiGenerateTextComponent extends CoreComponent implements OnInit {
  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;

  @Input('form') public form: FormGroup;
  @Input('control') public control: string;
  @Input('maxRows') public maxRows: number = 5;
  @Input('minRows') public minRows: number = 1;
  @Input('placeholderText') public placeholderText: string = '';
  @Input('content') public content: IMessageDescriptionDialogData;

  public subscription: Subscription;
  public isLoading: boolean = false;
  public contentDescriptionText: string = '';


  public clearText(): void {
    this.form.get(this.control).setValue('');
  }

  constructor(
    private dialog: MatDialog,
    private aiGenerateTextService: AiGenerateTextService,
  ) {
    super();
  }

  public ngOnInit(): void {
  }

  public closeMenu():void {
    this.isLoading = false;
    this.subscription && this.subscription.unsubscribe();
    this.menuTrigger && this.menuTrigger.closeMenu();
  }

  public generateAIText(): void {
    if (this.isLoading) return;
    const response = { message: this.contentDescriptionText };

    if (!response?.message) return;
    this.isLoading = true;

    const payload: IGenerateTextPayload = {
      includeEmojis: true,
      includeHashtags: false,
      customAdminContext: response.message,
    };

    this.subscription = this.aiGenerateTextService.generateAIText(payload).pipe(takeUntil(this.destroyed$)).subscribe({
      next: (responseData: IGenerateTextData) => {
        this.form.get(this.control).setValue(responseData.content);
      },
      error: (err: any) => {
        console.log(err);
      },
      complete: () => {
        this.closeMenu();
        this.isLoading = false;
        this.contentDescriptionText = '';
      }
    });
  }

  // It will be used in the V2 of AI- generate Text feature.
  // public openDialog(): void {
  //   const modalData: IMessageDescriptionDialogData = {
  //     title: this.content.title,
  //     description: this.content.description,
  //   };

  //   const dialogRef = this.dialog.open(MessageDescriptionDialogComponent,
  //     {
  //       data: modalData,
  //       width: MODAL_WIDTH.MD,
  //     },
  //   );

  //   dialogRef
  //     .afterClosed()
  //     .pipe(
  //       switchMap((response: { message: string }): Observable<IGenerateTextData> => {
  //         if (!response?.message) return of();
  //         const payload: IGenerateTextPayload = {
  //           includeEmojis: true,
  //           includeHashtags: false,
  //           customAdminContext: response.message,
  //         };
  //         return this.aiGenerateTextService.generateAIText(payload);
  //       }),
  //       takeUntil(this.destroyed$)
  //     )
  //     .subscribe({
  //       next: (response: IGenerateTextData): void => {
  //         this.form.get(this.control).setValue(response.content);
  //       },
  //       error: (err: any): void => {
  //         console.log(err);
  //       }
  //     });
  // }

  // public generateText(): void {
  //   const payload: IGenerateTextPayload = {
  //     includeEmojis: true,
  //     includeHashtags: false,
  //     customAdminContext: '',
  //   };

  //   this.aiGenerateTextService.generateAIText(payload)
  //     .pipe(
  //       takeUntil(this.destroyed$),
  //     )
  //     .subscribe({
  //       next: (response: IGenerateTextData): void => {
  //         this.form.get(this.control).setValue(response.content);
  //       },
  //       error: (err: any): void => {
  //         console.log(err);
  //       }
  //     });
  // }
}
